import React, { useState, useEffect, useCallback } from "react";
import { SALARY_BUDGET_CODES as BUDGET_CODES } from "./budjectCodes";
import { useSelector } from "react-redux";
import { PRE_PROPOSAL_STATUS, yearsFields } from "../../Constants";
import {
  applicantSelector,
  isLeaderSelector,
  canEditSelector,
} from "../../../../store/applicantsSlice";
import { useLoading } from "../../../../providers/loadingProvider";
import {
  pisColleaguesSelector,
  proposalSelector,
} from "../../../../store/proposalSlice";
import BudgetScreen from "./BudgetScreen";

export default function Salaries() {
  const loading = useLoading();
  const proposal = useSelector(proposalSelector);
  const [proposalApplicants, setProposalApplicants] = useState([]);
  const applicant = useSelector(applicantSelector);
  const isLeader = useSelector(isLeaderSelector);
  const canEdit = useSelector(canEditSelector);
  const colleagues = useSelector(pisColleaguesSelector);

  const getProposalApplicants = useCallback(async () => {
    if (!colleagues) return [];
    return colleagues.map((c) => ({
      id: c.id,
      name: c.name,
    }));
  }, [colleagues]);

  useEffect(() => {
    const getData = async () => {
      const loadingId = loading.addLoading("loading budgets");
      var shortProposalApplicants = await getProposalApplicants();
      setProposalApplicants(
        shortProposalApplicants.map((a) => ({ ...a, label: a.name }))
      );
      loading.removeLoading(loadingId);
      if (BUDGET_CODES.length === 0)
        throw new Error("BUDGET_CODES are not defined");
    };
    getData();
  }, [loading, getProposalApplicants]);

  const buildTableConfig = useCallback(
    (numberOfYears, budgetCodes) => {
      if (yearsFields.length < numberOfYears)
        throw new Error(
          `yearsFields length is less then number of years ${yearsFields.length} < ${numberOfYears}`
        );
      const yearsCols = [];
      for (let i = 0; i < numberOfYears; i++) {
        const element = yearsFields[i];
        yearsCols.push({
          id: element,
          label: numberOfYears === 1 ? `Cost` : `Year ${i + 1}`,
          field: element,
          type: "number",
        });
      }
      // if (numberOfYears > 1) {
      //   yearsCols.push({
      //     id: "total",
      //     label: "Total",
      //     type: "calculated",
      //     skipValidation: true,
      //     calculation: (row) =>
      //       yearsFields.map((f) => +row[f] || 0).reduce((a, b) => a + b, 0),
      //   });
      // }
      const activeProposalFields = [
        {
          id: "timein",
          label: "Time %",
          field: "timein",
          type: "number",
          limit: true,
        },
      ];

      const aditionalFieds =
        proposal.status === PRE_PROPOSAL_STATUS ? [] : activeProposalFields;
      const budgeType =
        budgetCodes.length > 1
          ? [
              {
                id: "budgetTypeInt",
                label: "Budget Code",
                field: "budgetTypeInt",
                type: "options",
                options: budgetCodes,
                width: 3,
              },
            ]
          : [];
      return {
        idField: "budgetClauseId",
        disableEdit: !canEdit,
        editOnlyId: applicant.id,
        editOnlyIdFiled: "applicantGranteeId",
        columns: [
          {
            id: "applicantGranteeId",
            label: "Name",
            field: "applicantGranteeId",
            type: "options",
            options: proposalApplicants,
            width: 3,
            disabled: !isLeader,
            skipValidation: true,
            value: applicant.id,
          },
          ...aditionalFieds,
          ...budgeType,
          {
            id: "justification",
            label: "Justification",
            field: "justification",
          },
          ...yearsCols,
        ],
      };
    },
    [applicant.id, canEdit, isLeader, proposalApplicants, proposal]
  );

  return (
    <BudgetScreen
      buildTableConfig={buildTableConfig}
      title="Personnel"
      infoField="Personnel"
      colleagues={colleagues}
      releventCodes={BUDGET_CODES}
    />
  );
}
